import React, {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import {logOut} from "../../redux/dataUploader/dataSlice";
import Loader from "../../components/loaders/Loader";
import MessageSendingData from "../../components/popups/MessageSendingData";
import Select from "react-select";
import {Link} from "react-router-dom";

import './mrx-campaigns-management.scss';

const MrxCampaignsManagement = () => {

  const token = localStorage.getItem("auth_token");
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(1);
  const [campaignID, setCampaignID] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState('');
  const [downloadFileUrl, setDownloadFileUrl] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [fileErrorMessage, setFileErrorMessage] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState({
      id: localStorage.getItem("id"),
      name: localStorage.getItem("name"),
  });
  const [trackingDomainsList, setTrackingDomainsList] = useState([]);
  const [selectedTrackingDomain, setSelectedTrackingDomain] = useState('');
  const [anAccounts, setAnAccounts] = useState([]);
  const [selectedANType, setSelectedANType] = useState({value: 'voluum', label: 'voluum'});
  const [selectedANAccount, setSelectedANAccount] = useState(null);
  const [selectedANAccountLabel, setSelectedANAccountLabel] = useState(null);
  const [anTypes, setAnTypes] = useState([]);
  const [restData, setRestData] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [confirmationPopupText, setConfirmationPopupText] = useState("");
  
  const checkSession = (status) => {
      if(status === 401) {
          dispatch(logOut());
      }
  }

  const selectStyles = {
    container: (baseStyles) => ({
        ...baseStyles,
        maxWidth: "180px",
        width: "100%",
        margin: "0 20px 0 0",
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        fontSize: "14px",
        lineHeight: "1.2",
        minHeight: "26px",
        border: "none",
        borderRadius: "8px",
        "&:hover": {
            cursor: "pointer",
        },
    }),
    placeholder: (baseStyles) => ({
        ...baseStyles,
        fontWeight: 500,
        color: "#1A3353",
    }),
    menu: (baseStyles, state) => ({
        ...baseStyles,
        zIndex: "6",
        "&:hover": {
            cursor: "pointer",
        },
    }),
    option: (baseStyles, state) => ({
        ...baseStyles,
        fontSize: "14px",
        lineHeight: "1.2",
        "&:hover": {
            cursor: "pointer",
        },
    }),
  }
  useEffect(() => {
      setIsLoading(true);

      // initial fetch
      fetch(`${localStorage.getItem("apiUrl")}api/user/${selectedUser.id}/services?status=true&is_archived=false`, {
          headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
      })
          .then(res => {
              checkSession(res.status);
              if (res.ok) {
                  return res.json()
              }
              return Promise.reject(res)
          })
          .then(res => {

              setSelectedUser({id: res.id, name: res.name})
              setUsersList([...res["user_managers_accounts"]])
              setAnTypes([])
              setAnAccounts([])
              if (res["user_services"] && res["user_services"].length > 0) {
                  let temp = []
                  let types = [] // for unique types
                  res["user_services"].forEach(item => {
                      if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name === "voluum" && item?.status === true) {
                          types.push(item?.types?.name)
                          temp.push({value: item?.types?.name, label: item?.types?.name})
                      }
                  })
                  setAnTypes(temp)
              }
              
              if(usersList.length === 0) {
                let tempB = [];
                
                tempB = res["user_services"].filter(item => item?.types?.name === 'voluum' && item?.status === true)
                tempB = tempB.reduce((acc, item) => {
                    acc.push({value: item.id, label: item.name})
                    return acc
                }, [])

                setAnAccounts(tempB)
                setSelectedANAccount(tempB[0]?.value || null);
              }

              setRestData(res)
              setIsLoading(false)
          })
          .catch(res => {
            setIsLoading(false)
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
          })
  }, []);

  const handleChangeSelectedUser = (user) => {
    setIsLoading(true);
    setSelectedANAccount(null);
    setSelectedANAccountLabel(null);
    setFileError(false);
    setFileErrorMessage(null);
    setValidationError(false);
    setValidationErrorMessage('');
    setDownloadFileUrl(null);
    setUploadedFile(null);
    setCampaignID('');
    setActiveTab(1);

    // fetch user services
    fetch(`${localStorage.getItem("apiUrl")}api/user/${user.value}/services?status=true&is_archived=false`, {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
        .then(res => {
            checkSession(res.status);
            if (res.ok) {
                return res.json()
            }
            return Promise.reject(res)
        })
        .then(res => {
            setSelectedUser({
                id: res.id,
                name: res.name
            })
            
            setAnTypes([])
            setAnAccounts([])
            if (res["user_services"] && res["user_services"].length > 0) {
                let temp = []
                let types = [] // for unique types
                res["user_services"].forEach(item => {
                    if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name === "voluum" && item?.status === true) {
                      types.push(item?.types?.name);
                      temp.push({value: item?.types?.name, label: item?.types?.name});
                    }
                })
                setAnTypes(temp);

                let tempB = []
                tempB = res["user_services"].filter(item => item?.types?.name === 'voluum' && item?.status === true)
                tempB = tempB.reduce((acc, item) => {
                    acc.push({value: item.id, label: item.name})
                    return acc
                }, [])
                if (tempB.length === 1) {
                  setSelectedANAccount(tempB[0].value);
                  setSelectedANAccountLabel(tempB[0].label);
                } else {
                  setSelectedANAccount(null);
                  setSelectedANAccountLabel(null);
                }

                setAnAccounts(tempB)
            }

            setRestData(res);
            setIsLoading(false);
        })
        .catch(res => {
            setIsLoading(false)
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
        })
  }

  const handleChangeANAccount = async (option) => {
    setSelectedANAccount(option.value);
    setSelectedANAccountLabel(option.label);
    getTrackingDomain(option.value);
  };

  const getTrackingDomain = async (accountID) => {
    setIsLoading(true);

    try {
      const response = await fetch(`${localStorage.getItem('apiUrl')}api/voluum/get-tracking-domains/${accountID || selectedANAccount }`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });

      checkSession(response.status);

      if (response.ok) {
        const data = await response.json();
        setTrackingDomainsList(data.domains);
      } else {
        throw new Error('Failed to fetch tracking domain');
      }
    } catch (error) {
      console.error(error.message);
    }
    setIsLoading(false);
  }

  const handleChangeSelectedTrackingDomain = (option) => {
    setSelectedTrackingDomain(option.value);

    setFileError(false);
    setFileErrorMessage([]);
  }

  const checkCampaignId = (e) => {
    // 8bf33209-ec89-4d11-921b-7a0950ce44ef
    // 7f19a5f0-bba7-429b-ace4-6559647d0e50
    const id = e.target.value;
    setCampaignID(id);

    if(id.length !== 0) {
      setValidationError(false);
      setValidationErrorMessage('');
    }
  }

  const changeCampaignFormSubmit = async (e) => {
    e.preventDefault();
    if(campaignID.length !== 0) {
      setValidationError(true);
      setValidationErrorMessage('');
      
      const data = JSON.stringify({
        "campaign_ids": JSON.stringify([campaignID])
      })

      setFormLoading(true);
      
      try {
        const response = await fetch(`${localStorage.getItem('apiUrl')}api/voluum/campaigns-management/${selectedANAccount}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          method: 'POST',
          body: data
        });

        checkSession(response.status);

        const result = await response.json();

        if (response.ok) {
          setDownloadFileUrl(result.file_urls[0]);
        } else {
          setDownloadFileUrl(null);
          let errorMsg;

          try {

            const parsedArray = JSON.parse(result.errors.message);
            let jsonString = parsedArray[0].replace("Error:", "").trim();
            let errorObj = JSON.parse(jsonString);

            if (Array.isArray(errorObj)) {
              errorMsg = `Error: ${errorObj[0]}`;
            } else if (typeof errorObj === "object" && errorObj !== null) {
              errorMsg = `Error: ${errorObj.code} - ${errorObj.description}`;
            } else {
              console.log('oops - unexpected format of error in responce');
            }

          } catch (error) {
            errorMsg = result.errors.message;
          }

          setValidationError(true);
          setValidationErrorMessage(errorMsg);
        }
      } catch (error) {
        console.error(error.message);
      }
      setFormLoading(false);
    } else {
      setValidationError(true);
      setDownloadFileUrl(null);
      setValidationErrorMessage('Please enter a valid campaign id');
    }
  }

  const fileUploaded = (e) => {
    setFormLoading(true);
  
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (fileExtension !== 'xlsx') {
        setFileError(true);
        setFileErrorMessage(['Only .xlsx files are allowed.']);
        setUploadedFile(null);
      } else {
        setFileError(false);
        setFileErrorMessage(null);
        setUploadedFile(file);
      }
    } else {
      setFileError(true);
      setFileErrorMessage(['No file selected. Please upload a file.']);
      setUploadedFile(null);
    }
  
    setFormLoading(false);
  };

  const sendFile = async () => {
    if (!uploadedFile) {
      setFileError(true);
      setFileErrorMessage(['No file selected. Please upload a file.']);
      return;
    }

    if (!selectedTrackingDomain) {
      setFileError(true);
      setFileErrorMessage(['Please select a Tracking Domain.']);
      return;
    }

    setFormLoading(true);
    setSuccessMessage('');
    const formData = new FormData();

    try {
      if (uploadedFile) {
        formData.append('campaign_file', uploadedFile);
        formData.append('tracking_domain', selectedTrackingDomain);
      } else {
        throw new Error('Uploaded file is invalid or missing.');
      }

      const response = await fetch(`${localStorage.getItem('apiUrl')}api/voluum/campaigns-management-upload/${selectedANAccount}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      checkSession(response.status);

      const result = await response.json();

      if (!response.ok) {
        setFileError(true);
        let errorMsg;

          try {
            const parsedArray = JSON.parse(result.errors.message);
            
            if (Array.isArray(parsedArray)) {
              let errorsArray;

              if(parsedArray[0].includes("Error:")) {
                let trimError = parsedArray[0].replace("Error:", "").trim();
                errorsArray = JSON.parse(trimError);
              } else {
                errorsArray = parsedArray;
              }

              setFileErrorMessage(errorsArray);
              setFormLoading(false);
              return;

            } else { 
              let jsonString = parsedArray.replace("Error:", "").trim();
              let errorObj = JSON.parse(jsonString);

              if (Array.isArray(errorObj)) {
                errorMsg = `Error: ${errorObj[0]}`;
              } else if (typeof errorObj === "object" && errorObj !== null) {
                errorMsg = `${errorObj.code} - ${errorObj.description}. ${errorObj.messages[0] ? `Message: ${errorObj.messages[0]}` : ""}`;
              } else {
                console.log('oops - unexpected format of error in responce');
              }
            }
          } catch (error) {
            errorMsg = result.errors.message;
          }

        setFileErrorMessage([errorMsg] || ['Failed to upload file. Please try again.']);
        setFormLoading(false);
        return;
      }

      setFileError(false);
      setFileErrorMessage(null);
      setSuccessMessage(result.message);
      setUploadedFile(null);
    } catch (error) {
      console.error('Error uploading file:', error.message);
      setFileError(true);
      setFileErrorMessage(['Failed to upload file. Please try again.']);
    }

    setFormLoading(false);
  };

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
    if (tab === 2) {
      setCampaignID(''); 
      getTrackingDomain();
    }

    setFileError(false);
    setFileErrorMessage(null);
    setValidationError(false);
    setValidationErrorMessage('');
    setDownloadFileUrl(null);
    setUploadedFile(null);
  };

  if (isLoading) {
    return <div className='loading-wrap'><Loader/></div>
  }

  return (
      <>
        <div className={`changed-campaigns-container`}>
          <div style={{
              display: "flex",
              alignItems: "center",
              margin: "0 0 10px",
          }}>

              <Select
                  className={""}
                  styles={selectStyles}
                  options={usersList.length !== 0 ? usersList
                      .slice()
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .reduce((acc, item) => {
                      acc.push({value: item.id, label: item.name})
                      return acc
                  }, []) : [{value: selectedUser.id, label: selectedUser.name}]}
                  isSearchable={true}
                  defaultValue={{value: selectedUser.id, label: selectedUser.name}}
                  name={"user"}
                  placeholder={"User"}
                  components={{
                      IndicatorSeparator: () => null
                  }}
                  onChange={(option) => handleChangeSelectedUser(option)}
              />
              
              <Select
                  className={""}
                  styles={selectStyles}
                  options={anAccounts
                      .slice()
                      .sort((a, b) => a.label.localeCompare(b.label))
                  }
                  isSearchable={true}
                  defaultValue={selectedANAccount}
                  name={"affiliate_network_account"}
                  placeholder={anAccounts.length === 1 ? anAccounts[0].label : 
                    selectedANAccountLabel ? selectedANAccountLabel : "Voluum Account"}
                  components={{
                      IndicatorSeparator: () => null
                  }}
                  onChange={(option) => handleChangeANAccount(option)}
              />

          </div>
        </div>
        { selectedANAccount && !formLoading ? (
          <div>
            <div className="tabsContainer">
              <div
                onClick={() => handleTabSwitch(1)}
                className={activeTab === 1 ? 'activeTab' : 'inactiveTab'}
              >
                Download Campaign
              </div>
              <div
                onClick={() => handleTabSwitch(2)}
                className={activeTab === 2 ? 'activeTab' : 'inactiveTab'}
              >
                Create/Update Campaign
              </div>
            </div>

            {/* Tab Content */}
            <div className="contentContainer">
              {activeTab === 1 ? (
                <div>
                  <p>Enter id of the campaign you want to change:</p>
                  <form>
                    <input type="text" onChange={checkCampaignId} value={campaignID || ''} placeholder="Campaign id" />
                    <input type="submit" className="blue-btn" onClick={changeCampaignFormSubmit} value="Submit" />
                    {validationError ? <p className="error">{validationErrorMessage}</p> : ''}
                  </form>
                  {downloadFileUrl ? (
                    <>
                      <p>
                        <a href={downloadFileUrl} download target="_blank" rel="noopener noreferrer">Download File</a> and upload it after you finish with all the needed updates
                        <button className="blue-btn show-upload-file-btn" onClick={() => setActiveTab(2)}>Upload File</button>
                      </p> 
                    </>
                  ) : '' }
                </div>
              ) : (
                <div>
                  <p>Update a campaign by uploading a file with the new configurations.</p>

                  <form
                    className="file-upload"
                    onSubmit={(e) => {
                      e.preventDefault();
                      sendFile();
                    }}
                  >
                    <p>Upload .xlsx file:</p>
                    <input
                      type="file"
                      onChange={fileUploaded}
                      className="file-input"
                    />

                    <p>Select Tracking Domain:</p>
                    <Select
                        className={"domain-input"}
                        styles={selectStyles}
                        options={trackingDomainsList.length !== 0 ? trackingDomainsList.reduce((acc, item) => {
                            acc.push({value: item, label: item})
                            return acc
                        }, []) : [{value: selectedTrackingDomain, label: selectedTrackingDomain}]}
                        isSearchable={true}
                        defaultValue={selectedTrackingDomain ? {value: selectedTrackingDomain, label: selectedTrackingDomain} : "Tracking Domain"}
                        name={"tracking-domain"}
                        placeholder={"Tracking Domain"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeSelectedTrackingDomain(option)}
                    />

                    {fileError && fileErrorMessage.map((item, index) => {
                        return <p className="error" key={index}>{item}</p> 
                      })
                    }
                    {successMessage && <p className="success">{successMessage}</p>}

                    <button
                      disabled={fileError || uploadedFile === null} 
                      className={`blue-btn ${uploadedFile === null ? 'disabled' : ''}`}
                      type="submit"
                    >
                      Submit
                    </button>
                  </form>
                  <p>You can create a new campaign by uploading a file with an empty campaign ID</p>
                  <p><a href={`${process.env.PUBLIC_URL}/download/campaign_example_template.xlsx`} download target="_blank" rel="noopener noreferrer">Download Template</a></p>
                </div>
              )}
            </div>
          </div>) : null
        }

        { formLoading && <Loader/> }
        
        {showConfirmationPopup && (
            <MessageSendingData
                messageText={confirmationPopupText}
                setClosePopup={() => setShowConfirmationPopup(false)}
            />
        )}
      </>
  )
}

export default MrxCampaignsManagement;
 
